module.exports = __webpack_public_path__ + "static/media/05_Ljuset i tunneln (ft. Lorentz)_(Akta Ljuset Prov)_rvsd 05-14.f226a1e0.mp3";